import React from 'react';
import EducatorsWhoCompletedProject from './EducatorsWhoCompletedProject';
import EducatorsAffiliatedWithNetworkSite from './EducatorsAffiliatedWithNetworkSite';
import EducatorsWithCompletedProject from './EducatorsWithCompletedProject';

export default function EducatorsWithCompletedProjectGroup(props) {
  return (
    <>
      <EducatorsWithCompletedProject {...props} />
      <EducatorsWhoCompletedProject {...props} />
      <EducatorsAffiliatedWithNetworkSite {...props} />
    </>
  )
}
